import React, { useEffect } from "react";
import { SectionWrapper } from "../../../../../UI/SectionWrapper/SectionWrapper";
import { Accordion, AccordionSummary } from "@mui/material";
import { ExpandMore } from "@mui/icons-material";
import { EPGTable } from "../../../../ui-components/pageLayout/EPGTable";
import { useSelector } from "react-redux";
import { store } from "../../../../store";
import styled from "styled-components";
import { AssetAccordionDetails } from "../../../../ui-components/pageLayout/TableSettingsComponents";
import {
  GetEPGAction,
  getEPGSelector,
} from "../../../../store/reducers/cmsReducer";
import { CMSAsset } from "@client/models/CMS/cmsAsset";

const EPGAccordionDetails = styled(AssetAccordionDetails)`
  max-height: 400px;
  overflow: scroll;
`;

interface IEPGAccordionProps {
  channel?: CMSAsset;
}

const EPGAccordion: React.FC<IEPGAccordionProps> = (props) => {
  const { channel } = props;

  const EPG = useSelector(getEPGSelector);

  useEffect(() => {
    if (!EPG.length && channel) {
      store.dispatch(GetEPGAction(channel.assetId));
    }
  }, [EPG, channel]);

  return (
    <>
      {!!EPG?.length && (
        <SectionWrapper>
          <Accordion defaultExpanded>
            <AccordionSummary
              expandIcon={<ExpandMore />}
              className="accordion-summary-gray"
            >
              EPG
            </AccordionSummary>
            <EPGAccordionDetails>
              <EPGTable EPG={EPG} />
            </EPGAccordionDetails>
          </Accordion>
        </SectionWrapper>
      )}
    </>
  );
};

export default EPGAccordion;
